exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".frameBustBtn{margin:20px auto!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/less-loader!./pages/xo-framebust/styles.less
 ** module id = 429
 ** module chunks = 1
 **/